import { Observer } from 'mobx-react-lite';
import React from 'react';
import joinClassName from '../../utils/className.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import { createMomentFn } from '../../utils/time.utils';
import './TimeDisplayer.scss';
var TimeDisplayer = function (props) {
    var _a;
    var p = useProps(props);
    var _createMoment = createMomentFn((_a = p.timezoneMode) !== null && _a !== void 0 ? _a : 'auto');
    var s = useStore(function () { return ({
        get emptyDisplayValue() {
            switch (p.format) {
                case 'HH:mm:ss':
                    return '--:--:--';
                case 'mm:ss':
                case 'HH:mm':
                    return '--:--';
                default:
                    return '';
            }
        },
        get machineTime() {
            return _createMoment(p.value || undefined).toISOString();
        },
        get displayTime() {
            return p.value ? _createMoment(p.value).local().format('HH:mm') : s.emptyDisplayValue;
        },
    }); });
    return React.createElement(Observer, { children: function () { return (React.createElement("time", { className: joinClassName('TimeDisplayer', p.className), dateTime: s.machineTime }, s.displayTime)); } });
};
export default TimeDisplayer;
